import React, { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import TextInput from "./TextInput"; // Adjust path accordingly
import { InputAdornment, Stack, Tooltip, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { isValidIban } from "util/validators/amka-afm";
import { Check, Warning } from "@mui/icons-material";

const IbanInput = (props) => {
  const { name, label, setParentValidIban = () => { }, ...other } = props;
  const { control, setValue } = useFormContext();
  const value = useWatch({ control, name });

  const [isValid, setIsValid] = useState(null);

  useEffect(() => {
    if (!value) {
      setIsValid(null);
      if (typeof setParentValidIban === "function") setParentValidIban(false);
    } else if (!value || value.length !== 27) {
      setIsValid(false);
      if (typeof setParentValidIban === "function") setParentValidIban(false);
    } else {
      const valid = isValidIban(value);
      setIsValid(valid);
      if (typeof setParentValidIban === "function") setParentValidIban(valid);
    }
  }, [value, setParentValidIban]);

  return (
    <TextInput
      name={name}
      blurFn={(e) => {
        const trimmedValue = e.target.value.replace(/\s+/g, "");
        setValue(name, trimmedValue);
      }}
      label={
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%" }}
          spacing={0}
        >
          <Typography>{label}</Typography>
          {value && (
            <Tooltip
              title={isValid ? "Έγκυρο ΙΒΑΝ" : "Μη έγκυρο ΙΒΑΝ"}
              placement="top"
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{
                  borderRadius: 999,
                  background: isValid ? "#cefad0" : "#ff930010",
                  pl: 1,
                  pr: 1,
                }}
              >
                <Typography color={isValid ? "#008631" : "#ff9300"}>
                  {isValid ? "Έγκυρο" : "Προσοχή"}
                </Typography>
                {isValid ? (
                  <Check color="success" fontSize="small" />
                ) : (
                  <Warning sx={{ color: "#ff9300" }} />
                )}
              </Stack>
            </Tooltip>
          )}
        </Stack>
      }
      {...other}
      otherInputProps={{}}
    />
  );
};

export default IbanInput;
